const state = {
    user: {},
    data: {},
    loading: false,
    userPassword: false,
    terms_conditions: {}
};

export default state;